module.exports = __webpack_public_path__ + "static/media/qrcode.e3352982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/qrcode.jpg
// module id = 340
// module chunks = 2